var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "padding0", attrs: { sm: "2" } },
            [
              _c("b-form-select", {
                staticClass: "float-left location-filter-select",
                attrs: { options: _vm.locationFilterOptions },
                model: {
                  value: _vm.locationFilter,
                  callback: function($$v) {
                    _vm.locationFilter = $$v
                  },
                  expression: "locationFilter"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "10" } }, [
            _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "flexRowEnd flexRowWrap marginB-32" },
                  [
                    _vm.tabIndex === 1
                      ? _c(
                          "download-csv",
                          {
                            attrs: {
                              data: _vm.screeningsByOrg,
                              name: "screenings.csv"
                            }
                          },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "bgDarkBlue marginR-5",
                                attrs: { variant: "primary" }
                              },
                              [
                                _vm._v("Download Screenings by Concern Level "),
                                _c("arrow-down", {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    color: "white"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tabIndex === 3
                      ? _c(
                          "download-csv",
                          {
                            attrs: {
                              data: _vm.laborScreeningsByOrg,
                              name: "screenings.csv"
                            }
                          },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "bgDarkBlue marginR-5",
                                attrs: { variant: "primary" }
                              },
                              [
                                _vm._v("Download Screenings by Conclusion "),
                                _c("arrow-down", {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    color: "white"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-button-toolbar",
                      { staticStyle: { margin: "0px 5px 15px 0px" } },
                      [
                        _c(
                          "download-csv",
                          {
                            staticStyle: { display: "inline" },
                            attrs: { data: _vm.allUsers, name: "users.csv" }
                          },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "bgDarkBlue float-right marginR-5",
                                attrs: { variant: "primary" }
                              },
                              [
                                _vm._v("Download Users "),
                                _c("arrow-down", {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    color: "white"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "download-csv",
                          {
                            attrs: {
                              data: _vm.allOrgs,
                              name: "organizations.csv"
                            }
                          },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "bgDarkBlue float-right marginR-5",
                                attrs: { variant: "primary" }
                              },
                              [
                                _vm._v("Download Orgs "),
                                _c("arrow-down", {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    color: "white"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "download-csv",
                          {
                            staticStyle: { display: "inline" },
                            attrs: { data: _vm.allGroups, name: "groups.csv" }
                          },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "bgDarkBlue float-right marginR-5",
                                attrs: { variant: "primary" }
                              },
                              [
                                _vm._v("Download Groups "),
                                _c("arrow-down", {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    color: "white"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "download-csv",
                          {
                            staticStyle: { display: "inline" },
                            attrs: { data: _vm.allLogs, name: "logs.csv" }
                          },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "bgDarkBlue float-right",
                                attrs: { variant: "primary" }
                              },
                              [
                                _vm._v("Download Logs "),
                                _c("arrow-down", {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    color: "white"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle.collapse1",
                            modifiers: { collapse1: true }
                          }
                        ],
                        staticClass: "filterBtn bgDarkBlue marginB0",
                        attrs: { variant: "primary" }
                      },
                      [
                        _vm._v("Time"),
                        _c("img", {
                          staticStyle: { "margin-left": "14px" },
                          attrs: {
                            src: require("../../../static/img/filterIcon.png"),
                            width: "17px",
                            height: "11px"
                          }
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    staticClass: "filterCollapse flexRowEnd",
                    attrs: { id: "collapse1" }
                  },
                  [
                    _c("b-card", [
                      _c("div", { staticClass: "div1" }, [
                        _c("span", [_vm._v("Time")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "div2" },
                        [
                          _c(
                            "b-form-radio-group",
                            {
                              attrs: {
                                id: "radiosBtn",
                                buttons: "",
                                "button-variant": "secondary",
                                name: "radiosBtn"
                              },
                              model: {
                                value: _vm.statisticsTimeInterval,
                                callback: function($$v) {
                                  _vm.statisticsTimeInterval = $$v
                                },
                                expression: "statisticsTimeInterval"
                              }
                            },
                            [
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "mx-0 firstBtn",
                                  attrs: { value: "Day" }
                                },
                                [_vm._v("Last 30 Days")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "mx-0",
                                  attrs: { value: "Month" }
                                },
                                [_vm._v("Month")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "mx-0",
                                  attrs: { value: "Quarter" }
                                },
                                [_vm._v("Quarter")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "mx-0",
                                  attrs: { value: "Year" }
                                },
                                [_vm._v("Year")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("date-range-picker", {
                            ref: "picker",
                            attrs: {
                              opens: "left",
                              "locale-data": {
                                firstDay: 1,
                                format: "dd-mm-yyyy"
                              },
                              maxDate: new Date(),
                              singleDatePicker: "range",
                              timePicker: false,
                              timePicker24Hour: false,
                              showWeekNumbers: false,
                              showDropdowns: true,
                              autoApply: false,
                              ranges: false
                            },
                            on: { select: _vm.handleSelect },
                            scopedSlots: _vm._u([
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "date-range-picker__header"
                                      },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            staticClass: "mb-0",
                                            attrs: {
                                              label: "Start Date:",
                                              "label-for": "startDate",
                                              "label-size": "sm"
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "mb-0",
                                              attrs: {
                                                "data-vv-name": "startDate",
                                                "data-vv-as": "startDate",
                                                id: "startDate",
                                                size: "sm",
                                                type: "text",
                                                name: "startDate"
                                              },
                                              model: {
                                                value:
                                                  _vm.customDateRange.startDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.customDateRange,
                                                    "startDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "customDateRange.startDate"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          {
                                            staticClass: "mb-0",
                                            attrs: {
                                              label: "End Date:",
                                              "label-for": "endDate",
                                              "label-size": "sm"
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "mb-0",
                                              attrs: {
                                                "data-vv-name": "endDate",
                                                "data-vv-as": "endDate",
                                                id: "endDate",
                                                size: "sm",
                                                type: "text",
                                                name: "endDate"
                                              },
                                              model: {
                                                value:
                                                  _vm.customDateRange.endDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.customDateRange,
                                                    "endDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "customDateRange.endDate"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "input",
                                fn: function() {
                                  return [
                                    _c(
                                      "b-button",
                                      {
                                        class: [
                                          "mx-0",
                                          {
                                            active:
                                              _vm.statisticsTimeInterval ===
                                              "Custom"
                                          }
                                        ],
                                        attrs: { variant: "secondary" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      Custom\n                    "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "footer",
                                fn: function(picker) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "date-range-picker__footer"
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              type: "button",
                                              variant: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveCustomDateRange(
                                                  picker.clickApply
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        Save\n                      "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.customDateRange,
                              callback: function($$v) {
                                _vm.customDateRange = $$v
                              },
                              expression: "customDateRange"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-radio",
                            {
                              staticClass: "mx-0 lastBtn",
                              attrs: {
                                button: "",
                                "button-variant": "secondary",
                                value: "All"
                              },
                              model: {
                                value: _vm.statisticsTimeInterval,
                                callback: function($$v) {
                                  _vm.statisticsTimeInterval = $$v
                                },
                                expression: "statisticsTimeInterval"
                              }
                            },
                            [_vm._v("All")]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          staticClass: "statisticsTabs",
          attrs: { id: "global-statistics-tabs" },
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _c(
            "b-tab",
            { attrs: { title: "Overall Demographics" } },
            [
              _c(
                "b-row",
                { staticClass: "marginB-14" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "padding0 marginR-42",
                      attrs: { sm: "12", md: "3" }
                    },
                    [
                      _c("b-card", { staticClass: "text-white bg-info" }, [
                        _c(
                          "div",
                          { staticClass: "flexRowBetween" },
                          [
                            _c("h1", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.rptgeneralCounts.personCount === null
                                      ? 0
                                      : _vm.rptgeneralCounts.personCount
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("account-icon", { attrs: { size: 45 } })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v("All People")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "padding0 marginR-42",
                      attrs: { sm: "12", md: "3" }
                    },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "text-white bg-danger clickable-card",
                          on: { click: _vm.goToConfirmed }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flexRowBetween flexRowAlignBaseline"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flexRowAlignBaseline" },
                                [
                                  _c("h1", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.rptgeneralCounts
                                          .confirmedPersonCount === null
                                          ? 0
                                          : _vm.rptgeneralCounts
                                              .confirmedPersonCount
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("h5", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.percentConfirmedPersons) +
                                        "%)"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/asterisk-white.png"),
                                  width: "28.83",
                                  height: "30"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("Confirmed Victims")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "padding0", attrs: { sm: "12", md: "3" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "clickable-card bg-secondary",
                          on: { click: _vm.goToBlankConfirmed }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flexRowBetween flexRowAlignBaseline"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flexRowAlignBaseline" },
                                [
                                  _c("h1", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.rptgeneralCounts
                                          .possiblePersonCount === null
                                          ? 0
                                          : _vm.rptgeneralCounts
                                              .possiblePersonCount
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("h5", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.percentUnconfirmedPersons) +
                                        "%)"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/pie-black.png"),
                                  width: "30",
                                  height: "30"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("Others")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-62" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("People over Time")
                  ]),
                  _vm._v(" "),
                  !_vm.rptpersonCountsByTimeError
                    ? _c("main-chart", {
                        staticClass: "chart-wrapper",
                        staticStyle: { height: "200px" },
                        attrs: {
                          height: "200",
                          chartName: "People",
                          apiData: _vm.rptpersonCountsByTime
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rptpersonCountsByTimeError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-62" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics by Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.demographicField,
                          callback: function($$v) {
                            _vm.demographicField = $$v
                          },
                          expression: "demographicField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.rptPersonCountsByDemographicError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.rptPersonCountsByDemographicError
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("All People")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.rptPersonCountsByDemographic,
                                    valueField: "personCount"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Total People",
                                      apiData: _vm.rptPersonCountsByDemographic,
                                      valueField: "personCount",
                                      groupedBy: _vm.demographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("Confirmed Victims")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.rptPersonCountsByDemographic,
                                    valueField: "confirmedVictimCount"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Confirmed Victims",
                                      apiData: _vm.rptPersonCountsByDemographic,
                                      valueField: "confirmedVictimCount",
                                      groupedBy: _vm.demographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("Others")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.rptPersonCountsByDemographic,
                                    valueField: "possibleVictimCount"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Possible Victims",
                                      apiData: _vm.rptPersonCountsByDemographic,
                                      valueField: "possibleVictimCount",
                                      groupedBy: _vm.demographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-62" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics over Time")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.demographicByTimeField,
                          callback: function($$v) {
                            _vm.demographicByTimeField = $$v
                          },
                          expression: "demographicByTimeField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("All People")
                      ]),
                      _vm._v(" "),
                      !_vm.rptpersonDemographicsOverTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData: _vm.rptpersonDemographicsOverTime,
                                valueField: "timeInterval",
                                demographicName: _vm.demographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData: _vm.rptpersonDemographicsOverTime,
                                  valueField: "timeInterval",
                                  demographicName: _vm.demographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptpersonDemographicsOverTimeError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Confirmed Victims")
                      ]),
                      _vm._v(" "),
                      !_vm.rptpersonDemographicsOverTimeConfirmedError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptpersonDemographicsOverTimeConfirmed,
                                valueField: "timeInterval",
                                demographicName: _vm.demographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptpersonDemographicsOverTimeConfirmed,
                                  valueField: "timeInterval",
                                  demographicName: _vm.demographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptpersonDemographicsOverTimeConfirmedError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Others")
                      ]),
                      _vm._v(" "),
                      !_vm.rptpersonDemographicsOverTimeUnconfirmedError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptpersonDemographicsOverTimeUnconfirmed,
                                valueField: "timeInterval",
                                demographicName: _vm.demographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptpersonDemographicsOverTimeUnconfirmed,
                                  valueField: "timeInterval",
                                  demographicName: _vm.demographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptpersonDemographicsOverTimeUnconfirmedError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            { attrs: { title: "CSE-IT" } },
            [
              _c(
                "div",
                { staticClass: "flexRowAlignCenter marginB-38" },
                [
                  _c(
                    "b-card",
                    { staticClass: "text-white bg-info marginR-42" },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween" },
                        [
                          _c("h1", [
                            _vm._v(
                              _vm._s(
                                _vm.rptgeneralCounts.cseitCount === null
                                  ? 0
                                  : _vm.rptgeneralCounts.cseitCount
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("account-icon", { attrs: { size: 45 } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("CSE-IT Screenings")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.rptgeneralCounts.cseitCountAllPerson === null
                              ? 0
                              : _vm.rptgeneralCounts.cseitCountAllPerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass: "clickable-card bg-secondary marginR-42",
                      on: { click: _vm.goToNoConcern }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.rptgeneralCounts.cseitCountNoConcern ===
                                      null
                                      ? 0
                                      : _vm.rptgeneralCounts.cseitCountNoConcern
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" + _vm._s(_vm.percentCseitNoconcern) + "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/pie-black.png"),
                              width: "30",
                              height: "30"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("No Concern")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.rptgeneralCounts.cseitCountNoConcernPerson ===
                              null
                              ? 0
                              : _vm.rptgeneralCounts.cseitCountNoConcernPerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass:
                        "text-white bg-warning clickable-card marginR-42",
                      on: { click: _vm.goToPossibleConcern }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.rptgeneralCounts
                                    .cseitCountPossibleConcern === null
                                    ? 0
                                    : _vm.rptgeneralCounts
                                        .cseitCountPossibleConcern
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.percentCseitPossibleConcern) +
                                  "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/alarm-white.png"),
                              width: "36.6",
                              height: "28.3"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("Possible Concern")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.rptgeneralCounts
                              .cseitCountPossibleConcernPerson === null
                              ? 0
                              : _vm.rptgeneralCounts
                                  .cseitCountPossibleConcernPerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass: "text-white bg-danger clickable-card",
                      on: { click: _vm.goToClearConcern }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.rptgeneralCounts
                                    .cseitCountClearConcern === null
                                    ? 0
                                    : _vm.rptgeneralCounts
                                        .cseitCountClearConcern
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.percentCseitClearConcern) +
                                  "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/asterisk-white.png"),
                              width: "28.83",
                              height: "30"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("Clear Concern")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.rptgeneralCounts
                              .cseitCountClearConcernPerson === null
                              ? 0
                              : _vm.rptgeneralCounts
                                  .cseitCountClearConcernPerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Screenings over Time")
                  ]),
                  _vm._v(" "),
                  !_vm.rptcseitCountsByTimeError
                    ? _c("main-chart", {
                        staticClass: "chart-wrapper",
                        staticStyle: { height: "200px" },
                        attrs: {
                          height: "200",
                          chartName: "Screenings",
                          apiData: _vm.rptcseitCountsByTime
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rptcseitCountsByTimeError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB0 paddingB0" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics by Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "cseitDemographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "cseitDemographic"
                        },
                        model: {
                          value: _vm.cseitDemographicField,
                          callback: function($$v) {
                            _vm.cseitDemographicField = $$v
                          },
                          expression: "cseitDemographicField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.rptcseitCountsByDemographicError ||
                  (_vm.rptcseitCountsByDemographic &&
                    _vm.rptcseitCountsByDemographic.length <= 0)
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { staticClass: "flexRowAround marginB-62" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("All Screenings")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData:
                                          _vm.rptcseitCountsByDemographic,
                                        valueField: "cseitCount"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Screenings",
                                          apiData:
                                            _vm.rptcseitCountsByDemographic,
                                          valueField: "cseitCount",
                                          groupedBy: _vm.cseitDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("No Concern")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData:
                                          _vm.rptcseitCountsByDemographic,
                                        valueField: "cseitCountNoConcern"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "No Concern",
                                          apiData:
                                            _vm.rptcseitCountsByDemographic,
                                          valueField: "cseitCountNoConcern",
                                          groupedBy: _vm.cseitDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "flexRowAround marginB-62" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("Possible Concern")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData:
                                          _vm.rptcseitCountsByDemographic,
                                        valueField: "cseitCountPossibleConcern"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Possible Concern",
                                          apiData:
                                            _vm.rptcseitCountsByDemographic,
                                          valueField:
                                            "cseitCountPossibleConcern",
                                          groupedBy: _vm.cseitDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("Clear Concern")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData:
                                          _vm.rptcseitCountsByDemographic,
                                        valueField: "cseitCountClearConcern"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Clear Concern",
                                          apiData:
                                            _vm.rptcseitCountsByDemographic,
                                          valueField: "cseitCountClearConcern",
                                          groupedBy: _vm.cseitDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics over Time")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.cseitDemographicByTimeField,
                          callback: function($$v) {
                            _vm.cseitDemographicByTimeField = $$v
                          },
                          expression: "cseitDemographicByTimeField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("All Screenings")
                      ]),
                      _vm._v(" "),
                      !_vm.rptcseitDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData: _vm.rptcseitDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.cseitDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData: _vm.rptcseitDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.cseitDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptcseitDemographicsByTimeError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("No Concern")
                      ]),
                      _vm._v(" "),
                      !_vm.rptcseitDemographicsOverTimeNoConcernError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptcseitDemographicsByTimeNoConcern,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.cseitDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptcseitDemographicsByTimeNoConcern,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.cseitDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptcseitDemographicsOverTimeNoConcernError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Possible Concern")
                      ]),
                      _vm._v(" "),
                      !_vm.rptcseitDemographicsOverTimePossibleConcernError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptcseitDemographicsByTimePossibleConcern,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.cseitDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptcseitDemographicsByTimePossibleConcern,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.cseitDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptcseitDemographicsOverTimePossibleConcernError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Clear Concern")
                      ]),
                      _vm._v(" "),
                      !_vm.rptcseitDemographicsOverTimeClearConcernError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptcseitDemographicsByTimeClearConcern,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.cseitDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptcseitDemographicsByTimeClearConcern,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.cseitDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptcseitDemographicsOverTimeClearConcernError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v("Indicators")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticStyle: { width: "400px" },
                          attrs: { "label-for": "demographic", horizontal: "" }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "lg",
                              options: _vm.cseitIndicatorOptions,
                              id: "demographic"
                            },
                            model: {
                              value: _vm.cseitIndicatorOption,
                              callback: function($$v) {
                                _vm.cseitIndicatorOption = $$v
                              },
                              expression: "cseitIndicatorOption"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12" } },
                        [
                          !_vm.rptCseitIndicatorsError
                            ? _c("horizontal-bar-chart", {
                                attrs: { apiData: _vm.rptCseitIndicators }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.rptCseitIndicatorsError
                            ? _c("p", [
                                _vm._v("There is no data for this chart.")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            { attrs: { title: "Lighthouse Indicators" } },
            [
              _c(
                "b-row",
                { staticClass: "marginB-14" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "padding0 marginR-42",
                      attrs: { sm: "12", md: "3" }
                    },
                    [
                      _c(
                        "b-card",
                        { staticClass: "text-white bg-info marginR-42" },
                        [
                          _c(
                            "div",
                            { staticClass: "flexRowBetween" },
                            [
                              _c("h1", [
                                _vm._v(
                                  _vm._s(
                                    _vm.rptgeneralCounts.assessmentCount ===
                                      null
                                      ? 0
                                      : _vm.rptgeneralCounts.assessmentCount
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("account-icon", { attrs: { size: 45 } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("All Lighthouse Screenings")
                          ]),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v(
                              _vm._s(
                                _vm.rptgeneralCounts
                                  .assessmentCountAllPerson === null
                                  ? 0
                                  : _vm.rptgeneralCounts
                                      .assessmentCountAllPerson
                              ) + " unique person(s)"
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "padding0 marginR-42",
                      attrs: { sm: "12", md: "3" }
                    },
                    [
                      _c("b-card", { staticClass: "bg-secondary marginR-42" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flexRowBetween flexRowAlignBaseline"
                          },
                          [
                            _c("div", { staticClass: "flexRowAlignBaseline" }, [
                              _c("h1", [
                                _vm._v(
                                  _vm._s(
                                    _vm.rptgeneralCounts
                                      .assessmentCountNotEnoughInfo === null
                                      ? 0
                                      : _vm.rptgeneralCounts
                                          .assessmentCountNotEnoughInfo
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("h5", [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.percentAssessmentNotenoughinfo) +
                                    "%)"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/pie-black.png"),
                                width: "30",
                                height: "30"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v("Not Enough Info")
                        ]),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rptgeneralCounts
                                  .assessmentCountNotEnoughInfoPerson === null
                                  ? 0
                                  : _vm.rptgeneralCounts
                                      .assessmentCountNotEnoughInfoPerson
                              ) +
                              " unique person(s)"
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "padding0", attrs: { sm: "12", md: "3" } },
                    [
                      _c("b-card", { staticClass: "text-white bg-warning" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flexRowBetween flexRowAlignBaseline"
                          },
                          [
                            _c("div", { staticClass: "flexRowAlignBaseline" }, [
                              _c("h1", [
                                _vm._v(
                                  _vm._s(
                                    _vm.rptgeneralCounts
                                      .assessmentCountPossible === null
                                      ? 0
                                      : _vm.rptgeneralCounts
                                          .assessmentCountPossible
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("h5", [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.percentAssessmentPossible) +
                                    "%)"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/alarm-white.png"),
                                width: "36.6",
                                height: "28.3"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v("Possible Victim")
                        ]),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v(
                            _vm._s(
                              _vm.rptgeneralCounts
                                .assessmentCountPossiblePerson === null
                                ? 0
                                : _vm.rptgeneralCounts
                                    .assessmentCountPossiblePerson
                            ) + " unique person(s)"
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Lighthouse Screenings over Time")
                  ]),
                  _vm._v(" "),
                  !_vm.rptassessmentCountsByTimeError
                    ? _c("main-chart", {
                        staticClass: "chart-wrapper",
                        staticStyle: { height: "200px" },
                        attrs: {
                          height: "200",
                          chartName: "Assessments",
                          apiData: _vm.rptassessmentCountsByTime
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rptassessmentCountsByTimeError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics by Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.assessmentDemographicField,
                          callback: function($$v) {
                            _vm.assessmentDemographicField = $$v
                          },
                          expression: "assessmentDemographicField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.rptassessmentByDemographicError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.rptassessmentByDemographicError
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("All Lighthouse Screenings")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData:
                                      _vm.rptassessmentCountsByDemographic,
                                    valueField: "assessmentCount"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Total People",
                                      apiData:
                                        _vm.rptassessmentCountsByDemographic,
                                      valueField: "assessmentCount",
                                      groupedBy: _vm.assessmentDemographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("Not Enough Information")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData:
                                      _vm.rptassessmentCountsByDemographic,
                                    valueField: "assessmentCountNotEnoughInfo"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Possible Victims",
                                      apiData:
                                        _vm.rptassessmentCountsByDemographic,
                                      valueField:
                                        "assessmentCountNotEnoughInfo",
                                      groupedBy: _vm.assessmentDemographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("Possible Victim")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData:
                                      _vm.rptassessmentCountsByDemographic,
                                    valueField: "assessmentCountPossible"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Confirmed Victims",
                                      apiData:
                                        _vm.rptassessmentCountsByDemographic,
                                      valueField: "assessmentCountPossible",
                                      groupedBy: _vm.assessmentDemographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics over Time")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.assessmentDemographicByTimeField,
                          callback: function($$v) {
                            _vm.assessmentDemographicByTimeField = $$v
                          },
                          expression: "assessmentDemographicByTimeField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("All Lighthouse Screenings")
                      ]),
                      _vm._v(" "),
                      !_vm.rptassessmentDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData: _vm.rptassessmentDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.assessmentDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData: _vm.rptassessmentDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.assessmentDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptassessmentDemographicsByTimeError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Not Enough Information")
                      ]),
                      _vm._v(" "),
                      !_vm.rptassessmentDemographicsOverTimeNoInfoError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptassessmentDemographicsByTimeNoInfoVictims,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.assessmentDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptassessmentDemographicsByTimeNoInfoVictims,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.assessmentDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rptassessmentDemographicsOverTimeNoInfoError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Possible Victim")
                  ]),
                  _vm._v(" "),
                  !_vm.rptassessmentDemographicsOverTimePossibleError
                    ? _c(
                        "chart-legend-wrap",
                        {
                          attrs: {
                            type: "stacked-line",
                            apiData:
                              _vm.rptassessmentDemographicsByTimePossibleVictims,
                            valueField: "timeInterval",
                            demographicName:
                              _vm.assessmentDemographicByTimeField,
                            colorValues: _vm.colorValues
                          }
                        },
                        [
                          _c("stacked-line-chart", {
                            staticClass: "chart-wrapper",
                            staticStyle: { height: "200px" },
                            attrs: {
                              height: "200",
                              chartName: "Demographics over Time",
                              apiData:
                                _vm.rptassessmentDemographicsByTimePossibleVictims,
                              valueField: "timeInterval",
                              demographicName:
                                _vm.assessmentDemographicByTimeField,
                              colorValues: _vm.colorValues
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rptassessmentDemographicsOverTimePossibleError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v("Indicators")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flexRowJustifyCenter" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticStyle: { width: "450px" },
                          attrs: { "label-for": "demographic", horizontal: "" }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "lg",
                              options: _vm.assessmentIndicatorOptions,
                              id: "demographic"
                            },
                            model: {
                              value: _vm.assessmentIndicatorOption,
                              callback: function($$v) {
                                _vm.assessmentIndicatorOption = $$v
                              },
                              expression: "assessmentIndicatorOption"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12" } },
                        [
                          !_vm.rptassessmentIndicatorsError
                            ? _c("horizontal-bar-chart", {
                                attrs: { apiData: _vm.rptassessmentIndicators }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.rptassessmentIndicatorsError
                            ? _c("p", [
                                _vm._v("There is no data for this chart.")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            { attrs: { title: "Labor Screening" } },
            [
              _c(
                "div",
                { staticClass: "flexRowAlignCenter marginB-38" },
                [
                  _c(
                    "b-card",
                    { staticClass: "text-white bg-info marginR-42" },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween" },
                        [
                          _c("h1", [
                            _vm._v(_vm._s(_vm.rptgeneralCounts.lsCount))
                          ]),
                          _vm._v(" "),
                          _c("account-icon", { attrs: { size: 45 } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("Labor Screenings")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(_vm.rptgeneralCounts.lsCountAllPerson) +
                            " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass: "clickable-card bg-secondary marginR-42",
                      on: { click: _vm.goToLSNotEnoughInfo }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.rptgeneralCounts.lsCountNotEnoughInfo
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" + _vm._s(_vm.percentLsNotEnoughInfo) + "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/pie-black.png"),
                              width: "30",
                              height: "30"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("Not Enough Info")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.rptgeneralCounts.lsCountNotEnoughInfoPerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass:
                        "text-white bg-warning clickable-card marginR-42",
                      on: { click: _vm.goToLSVulnerable }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(_vm.rptgeneralCounts.lsCountVulnerable)
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" + _vm._s(_vm.percentLsVulnerable) + "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/alarm-white.png"),
                              width: "36.6",
                              height: "28.3"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("Level 1: Concern")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(_vm.rptgeneralCounts.lsCountVulnerablePerson) +
                            " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass: "text-white bg-danger clickable-card",
                      on: { click: _vm.goToLSHighlyVulnerable }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.rptgeneralCounts.lsCountHighlyVulnerable
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.percentLsHighlyVulnerable) +
                                  "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/asterisk-white.png"),
                              width: "28.83",
                              height: "30"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("Level 2: Indicated")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.rptgeneralCounts.lsCountHighlyVulnerablePerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Screenings over Time")
                  ]),
                  _vm._v(" "),
                  !_vm.rptLaborScreeningCountsByTimeError
                    ? _c("main-chart", {
                        staticClass: "chart-wrapper",
                        staticStyle: { height: "200px" },
                        attrs: {
                          height: "200",
                          chartName: "Screenings",
                          apiData: _vm.rptLaborScreeningCountsByTime
                        }
                      })
                    : _c("p", [_vm._v("There is no data for this chart.")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics by Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-size": "lg",
                        "label-text-align": "left",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "laborScreeningDemographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "laborScreeningDemographic"
                        },
                        model: {
                          value: _vm.laborScreeningDemographicField,
                          callback: function($$v) {
                            _vm.laborScreeningDemographicField = $$v
                          },
                          expression: "laborScreeningDemographicField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.rptLaborScreeningCountsByDemographicError ||
                  (_vm.rptLaborScreeningCountsByDemographic &&
                    _vm.rptLaborScreeningCountsByDemographic.length <= 0)
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { staticClass: "flexRowAround marginB-62" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("All Screenings")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData:
                                          _vm.rptLaborScreeningCountsByDemographic,
                                        valueField: "lsCount"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Screenings",
                                          apiData:
                                            _vm.rptLaborScreeningCountsByDemographic,
                                          valueField: "lsCount",
                                          groupedBy:
                                            _vm.laborScreeningDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("Not Enough Info")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData:
                                          _vm.rptLaborScreeningCountsByDemographic,
                                        valueField: "lsCountNotEnoughInfo"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Not Enough Info",
                                          apiData:
                                            _vm.rptLaborScreeningCountsByDemographic,
                                          valueField: "lsCountNotEnoughInfo",
                                          groupedBy:
                                            _vm.laborScreeningDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "flexRowAround" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("Level 1: Concern")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData:
                                          _vm.rptLaborScreeningCountsByDemographic,
                                        valueField: "lsCountVulnerable"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Level 1: Concern",
                                          apiData:
                                            _vm.rptLaborScreeningCountsByDemographic,
                                          valueField: "lsCountVulnerable",
                                          groupedBy:
                                            _vm.laborScreeningDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("Level 2: Indicated")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData:
                                          _vm.rptLaborScreeningCountsByDemographic,
                                        valueField: "lsCountHighlyVulnerable"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Level 2: Indicated",
                                          apiData:
                                            _vm.rptLaborScreeningCountsByDemographic,
                                          valueField: "lsCountHighlyVulnerable",
                                          groupedBy:
                                            _vm.laborScreeningDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics over Time")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      staticStyle: { width: "400px" },
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.laborScreeningDemographicByTimeField,
                          callback: function($$v) {
                            _vm.laborScreeningDemographicByTimeField = $$v
                          },
                          expression: "laborScreeningDemographicByTimeField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("All Screenings")
                      ]),
                      _vm._v(" "),
                      !_vm.rptLaborScreeningDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptLaborScreeningDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.laborScreeningDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptLaborScreeningDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.laborScreeningDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _c("p", [_vm._v("There is no data for this chart.")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Not Enough Info")
                      ]),
                      _vm._v(" "),
                      !_vm.rptLaborScreeningDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptLaborScreeningDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.laborScreeningDemographicByTimeField,
                                demographicTotalKey: "demographicNotEnoughInfo",
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptLaborScreeningDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.laborScreeningDemographicByTimeField,
                                  demographicTotalKey:
                                    "demographicNotEnoughInfo",
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _c("p", [_vm._v("There is no data for this chart.")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Level 1: Concern")
                      ]),
                      _vm._v(" "),
                      !_vm.rptLaborScreeningDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptLaborScreeningDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.laborScreeningDemographicByTimeField,
                                demographicTotalKey: "demographicVulnerable",
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptLaborScreeningDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.laborScreeningDemographicByTimeField,
                                  demographicTotalKey: "demographicVulnerable",
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _c("p", [_vm._v("There is no data for this chart.")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v("Level 2: Indicated")
                      ]),
                      _vm._v(" "),
                      !_vm.rptLaborScreeningDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.rptLaborScreeningDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.laborScreeningDemographicByTimeField,
                                demographicTotalKey:
                                  "demographicHighlyVulnerable",
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: {
                                  height: "200px",
                                  "margin-top": "40px"
                                },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.rptLaborScreeningDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.laborScreeningDemographicByTimeField,
                                  demographicTotalKey:
                                    "demographicHighlyVulnerable",
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _c("p", [_vm._v("There is no data for this chart.")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v("Indicators")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticStyle: { width: "420px" },
                          attrs: { "label-for": "demographic", horizontal: "" }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "lg",
                              options: _vm.laborScreeningIndicatorOptions,
                              id: "demographic"
                            },
                            model: {
                              value: _vm.laborScreeningIndicatorOption,
                              callback: function($$v) {
                                _vm.laborScreeningIndicatorOption = $$v
                              },
                              expression: "laborScreeningIndicatorOption"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12" } },
                        [
                          _c(
                            "b-tabs",
                            [
                              _c(
                                "b-tab",
                                { attrs: { title: "Ends" } },
                                [
                                  !_vm.rptLaborScreeningIndicatorsError &&
                                  _vm.rptLaborScreeningIndicatorsEnds &&
                                  _vm.rptLaborScreeningIndicatorsEnds.length
                                    ? _c("horizontal-bar-chart", {
                                        attrs: {
                                          transformKeyFunction:
                                            _vm.transformLaborScreeningIndicatorKey,
                                          apiData:
                                            _vm.rptLaborScreeningIndicatorsEnds
                                        }
                                      })
                                    : _c("p", [
                                        _vm._v(
                                          "There is no data for this chart."
                                        )
                                      ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                { attrs: { title: "Means" } },
                                [
                                  !_vm.rptLaborScreeningIndicatorsError &&
                                  _vm.rptLaborScreeningIndicatorsMeans &&
                                  _vm.rptLaborScreeningIndicatorsMeans.length
                                    ? _c("horizontal-bar-chart", {
                                        attrs: {
                                          transformKeyFunction:
                                            _vm.transformLaborScreeningIndicatorKey,
                                          apiData:
                                            _vm.rptLaborScreeningIndicatorsMeans
                                        }
                                      })
                                    : _c("p", [
                                        _vm._v(
                                          "There is no data for this chart."
                                        )
                                      ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                { attrs: { title: "Process" } },
                                [
                                  !_vm.rptLaborScreeningIndicatorsError &&
                                  _vm.rptLaborScreeningIndicatorsProcess &&
                                  _vm.rptLaborScreeningIndicatorsProcess.length
                                    ? _c("horizontal-bar-chart", {
                                        attrs: {
                                          transformKeyFunction:
                                            _vm.transformLaborScreeningIndicatorKey,
                                          apiData:
                                            _vm.rptLaborScreeningIndicatorsProcess
                                        }
                                      })
                                    : _c("p", [
                                        _vm._v(
                                          "There is no data for this chart."
                                        )
                                      ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64d0b5bf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d0b5bf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/GlobalReport.vue
// module id = 1934
// module chunks = 0